import store from './../store';
import {useEffect, useState} from "react";

import {getCurrentLayout} from "../bvcomponents/appLayout";
import {setAllFeaturesLoaded} from "./serverFunctions";
import JsonApi from "../api/jsonApi";
import {useIsMounted} from "../misc/helperHooks";
import {getBvFeatures} from "../api/server-api";


export const downloadAllFeatures = async () => {
  const mainResponse = await JsonApi.getBathroomVisualizerData(100000);
  if (!mainResponse || !mainResponse.data || !mainResponse.data.features) {
    return false
  }
  const layout = getCurrentLayout();
  layout.loadNewFeatures(mainResponse.data);
  layout.getFeatures().forEach((parentGroup) => {
    parentGroup.relatedItems.forEach((relatedItem) => {
      relatedItem.allFeaturesReceived = true;
    })
  })
  store.dispatch(setAllFeaturesLoaded(document.kvConfig.visualizerType))
  return true
};

export const useFeaturesRoomLayoutsChecker = () => { // not used for now!

  const [featuresLoaded, setFeaturesLoaded] = useState(false);
  const isMounted = useIsMounted();

  const checkFeatures = async () => {
    const layout = getCurrentLayout();
    const featureGroupsObjects = layout.getActiveFeatures(true, false, true)
        .filter(fgObject => !fgObject.partId.includes("decor_") && !fgObject.partId.includes("attachment")); // they are already received
    // console.log("featureGroupsObjects", featureGroupsObjects);
    let needToRequestNames = [];
    featureGroupsObjects.forEach((featureGroupObject) => {
      if (featureGroupObject.featureGroup
          && !featureGroupObject.realFeaturesReceived
          && featureGroupObject.cartFeature
          && featureGroupObject.cartFeature.dbFeature
          && featureGroupObject.cartFeature.dbFeature.sharedFeatureName
          && !needToRequestNames.includes(featureGroupObject.cartFeature.dbFeature.sharedFeatureName)
          && (!featureGroupObject.featureGroup.alreadyRequestedFeatureNames
              || !featureGroupObject.featureGroup.alreadyRequestedFeatureNames.includes(featureGroupObject.cartFeature.dbFeature.sharedFeatureName))) {
        if (!featureGroupObject.featureGroup.alreadyRequestedFeatureNames) {
          featureGroupObject.featureGroup.alreadyRequestedFeatureNames = [];
        }
        needToRequestNames.push(featureGroupObject.cartFeature.dbFeature.sharedFeatureName)
        featureGroupObject.featureGroup.alreadyRequestedFeatureNames.push(featureGroupObject.cartFeature.dbFeature.sharedFeatureName)
      }
    });
    console.log("needToRequestNames", needToRequestNames);
    if (!needToRequestNames.length) {
      setFeaturesLoaded(true)
      return
    }
    const missingSkusResponse = await getBvFeatures(null, needToRequestNames, true);
    if (missingSkusResponse && missingSkusResponse.data) {
      console.log("missingSkusResponse", missingSkusResponse.data);
      layout.loadNewFeatures(missingSkusResponse.data);
    }
    if (isMounted()) {
      setFeaturesLoaded(true)
    }
  }

  useEffect(() => {
    checkFeatures()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return featuresLoaded
}
